import { Box, IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import OpenInFullIcon from "@mui/icons-material/OpenInFull"
import { changeView, openRunDialog } from "./MaintenanceSlice"
import { useAppDispatch } from "../../util/hooks"
export const SideView = ({ children }: any) => {
  const dispatch = useAppDispatch()
  const expand = () => {
    dispatch(openRunDialog())
  }
  const closeSideView = () => {
    dispatch(changeView(false))
  }
  return (
    <Box padding={2}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <IconButton
          aria-label="close"
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
          onClick={closeSideView}
        >
          <CloseIcon />
        </IconButton>
        <IconButton
          aria-label="close"
          onClick={expand}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <OpenInFullIcon />
        </IconButton>
      </Box>
      {children}
    </Box>
  )
}
